export default __webpack_public_path__ + "static/media/smiling-in-car.3cbb3eda.jpg";